import { Character } from "./types";

export const defaultCharacter: Character = {
	// Basic Info
	name: "",
	race: "",
	class: "",
	level: 1,
	background: "",
	alignment: "",
	experiencePoints: 0,

	// Abilities
	abilities: {
		strength: 10,
		dexterity: 10,
		constitution: 10,
		intelligence: 10,
		wisdom: 10,
		charisma: 10,
	},

	// Combat Stats
	armorClass: 10,
	initiative: 0,
	speed: 30,
	hitPointsMax: 10,
	hitPointsCurrent: 10,
	tempHitPoints: 0,
	hitDice: "1d8",
	deathSaves: { successes: 0, failures: 0 },

	// Skills & Saves
	proficiencyBonus: 2,
	skills: {
		acrobatics: { proficient: false },
		animalHandling: { proficient: false },
		arcana: { proficient: false },
		athletics: { proficient: false },
		deception: { proficient: false },
		history: { proficient: false },
		insight: { proficient: false },
		intimidation: { proficient: false },
		investigation: { proficient: false },
		medicine: { proficient: false },
		nature: { proficient: false },
		perception: { proficient: false },
		performance: { proficient: false },
		persuasion: { proficient: false },
		religion: { proficient: false },
		sleightOfHand: { proficient: false },
		stealth: { proficient: false },
		survival: { proficient: false },
	},
	savingThrows: {
		strength: { proficient: false },
		dexterity: { proficient: false },
		constitution: { proficient: false },
		intelligence: { proficient: false },
		wisdom: { proficient: false },
		charisma: { proficient: false },
	},

	// Other
	inspiration: false,
	passivePerception: 10,
	proficiencies: "",
	languages: "",

	// Equipment
	equipment: [],
	attacks: [],

	// Features & Traits
	features: [],

	// Spellcasting
	spellcastingAbility: "",
	spellSaveDC: 8,
	spellAttackBonus: 0,
	spells: {
		0: [],
		1: [],
		2: [],
		3: [],
		4: [],
		5: [],
		6: [],
		7: [],
		8: [],
		9: [],
	},
	spellSlots: {
		1: { total: 0, used: 0 },
		2: { total: 0, used: 0 },
		3: { total: 0, used: 0 },
		4: { total: 0, used: 0 },
		5: { total: 0, used: 0 },
		6: { total: 0, used: 0 },
		7: { total: 0, used: 0 },
		8: { total: 0, used: 0 },
		9: { total: 0, used: 0 },
	},

	// Character Details
	personalityTraits: "",
	ideals: "",
	bonds: "",
	flaws: "",
	backstory: "",
	alliesOrganizations: "",

	// Treasure
	copper: 0,
	silver: 0,
	electrum: 0,
	gold: 0,
	platinum: 0,
	otherTreasure: "",
};
